import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers/DatePicker";
import { TextField } from "@mui/material";
import clsx from "clsx";
import Text from "../../styleguide/Text";

interface DatePicker {
  label?: string;
  placeholder?: string;
  handleChangeDate?: (newValue: Date | null) => void;
  value?: Date | string | null;
  disabled?: boolean;
  className?: string;
  withVerticalSpacer?: boolean;
  isRequired?: boolean;
  touched?: boolean;
  error?: string;
  textInputClassName?: string;
  dateFormat?: string;
  fullWith?: boolean;
  gutterBottom?: boolean;
  maxDate?: Date;
  minDate?: Date;
  withClearData?: boolean;
  size?: "small" | "medium";
}

const DatePicker = ({
  label,
  placeholder,
  handleChangeDate,
  value,
  disabled,
  className,
  withVerticalSpacer,
  isRequired,
  textInputClassName,
  dateFormat = "D/MM/yyyy",
  fullWith = true,
  gutterBottom = true,
  maxDate,
  minDate,
  withClearData,
  touched,
  error,
  size = "medium",
}: DatePicker) => {
  const handleChange = (newValue: Date | null) => {
    if (withClearData) {
      handleChangeDate && handleChangeDate(newValue);
      return;
    }
    if (newValue) {
      handleChangeDate && handleChangeDate(newValue);
    }
  };
  return (
    <div
      className={`${fullWith ? "w-100" : ""} ${
        withVerticalSpacer ? "px-1" : ""
      } ${className}`}>
      <MuiDatePicker
        componentsProps={{
          actionBar: {
            actions: withClearData ? ["clear"] : [],
          },
        }}
        value={value || null}
        inputFormat={dateFormat}
        disableMaskedInput
        onChange={handleChange}
        disabled={disabled}
        maxDate={maxDate}
        minDate={minDate}
        className={clsx(
          "form-control form-control-solid mb-3 mb-lg-0",
          { "is-invalid": error && touched },
          {
            "is-valid": !error && touched,
          },
          textInputClassName,
        )}
        renderInput={(params) => (
          <div className={`d-flex flex-column ${gutterBottom ? "mb-7" : ""}`}>
            {label && (
              <label
                className={`${
                  isRequired && "required"
                } fs-6 mb-2 form-label fw-bolder text-dark`}>
                {label}
              </label>
            )}
            <TextField
              sx={{
                "& fieldset": { border: "none" },
              }}
              size={size}
              variant="outlined"
              placeholder={placeholder}
              {...params}
              onKeyDown={(e) => {
                e.preventDefault();
              }}
            />
          </div>
        )}
      />
      {touched && error && (
        <div>
          <Text variant="body1" color="red" role="alert" className="mt-1">
            {error}
          </Text>
        </div>
      )}
    </div>
  );
};

export default DatePicker;
